import {EnvironmentKind} from '../enum/environment.kind';

export interface INickDataBaseConnection {
    host?: string;
    port?: number;
    key?: string;
    user?: string;
    password?: string;
    kind?: EnvironmentKind;
    replicas?: INickDataBaseConnection[];
}
